// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2hR-d","avatar":"avatar___3kC27","overlay":"overlay___22WAO","total":"total___2PZZp","number":"number___34zU4"};